<template>
	<div class="usermodule">
		<div class="contextleft">
			<a href="javascript:void(0);" @click="inlearningrecords"
				:class="{contextleftactive:type==''||type=='学习记录'}">
				<div>
					<label style="height: calc(7.5rem / 6);display: block;"></label>
					<p>学习</p>
					<p>路径</p>
				</div>
			</a>
			<a href="javascript:void(0);" @click="inachievement" :class="{contextleftactive:type=='考试成绩'}">
				<div>
					<label style="height: calc(7.5rem / 6);display: block;"></label>
					<p>考试</p>
					<p>成绩</p>
				</div>
			</a>
			<a href="javascript:void(0);" @click="inmessagereply" :class="{contextleftactive:type=='留言和回复'}">
				<div>
					<label style="height: calc(7.5rem / 6);display: block;"></label>
					<p>留言</p>
					<p>回复</p>
				</div>
			</a>
			<a href="javascript:void(0);" @click="inmessagereply2" :class="{contextleftactive:type=='文章专栏'}">
				<div>
					<label style="height: calc(7.5rem / 6);display: block;"></label>
					<p>文章</p>
					<p>发布</p>
				</div>
			</a>
		</div>
		<div class="contextright">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'usermodule',
		data() {
			return {
				type:this.$route.meta.title
			}
		},
		methods: {
			inlearningrecords() {
				this.type = '学习记录'
				this.$router.push('/personal/usermodule/learningrecords')
			},
			inachievement() {
				this.type = '考试成绩'
				this.$router.push('/personal/usermodule/achievement')
			},
			inmessagereply() {
				this.type = '留言和回复'
				this.$router.push('/personal/usermodule/messagereply')
			},
			inmessagereply2() {
				this.type = '文章专栏'
				this.$router.push('/personal/usermodule/specialcolumn')
			}
		}
	}
</script>

<style>
	.usermodule{
		margin-top: 1rem;
	}
	.usermodule .contextleft {
		width: 7.5rem;
		height: auto;
		text-align: center;
		line-height: 3rem;
		margin-right: 0.5rem;
		float: left;
	}

	.usermodule .contextleft div  {
		width: 7.5rem;
		height: 7.5rem;
		background: url(../../assets/images/select1.png) no-repeat;
		background-size: 100% 100%;
		margin-bottom: 1rem;
		color: #a2693f;
		line-height: calc(7.5rem / 3);
		font-size: 1.857142rem;
		font-family: 'STXingkai' !important;
	}
	.usermodule .contextleft div p:first-child{
		
	}

	.usermodule .contextright {
		width: calc(100% - 8rem);
		height: auto;
		background: linear-gradient(to bottom right, #aa7a57, #dbb48a);
		position: relative;
		margin-left: 8rem;
	}

	.usermodule .contextright1 {
		margin: 2px;
		background: #FFFFFF;
	}

	.usermodule .contextright2 {
		margin: 1px;
		border: 1px solid #dbb48a;
	}

	.usermodule .contextleftactive {
		position: relative;
		display: block;
	}

	.usermodule a {
		text-decoration: none;
	}

	.usermodule .contextleftactive div {
		background: url(../../assets/images/select2.png) no-repeat;
		background-size: 100% 100%;
		color: #FFFFFF !important;
	}

	.usermodule .usercontexttop {
		height: 3rem;
		background: #a2693f;
		padding-left: 1rem;
	}

	.usermodule .usercontexttop div:first-child {
		width: 10rem;
	}

	.usermodule .usercontexttop div:last-child {
		width: calc(100% - 12rem);
	}

	.usermodule .usercontexttop div {
		width: calc(50% - 1rem);
		height: 2rem;
		float: left;
		color: #d49f79;
		font-size: 1.285714rem;
		line-height: 2rem;
		padding: 0.5rem;
	}

	.usermodule .btnpage {
		text-align: right;
	}

	.usermodule .btnpage2 {
		text-align: center;
		margin-top: 1rem;
		position: absolute;
		bottom: -6rem;
		left: 0;
		right: 0;
		padding-bottom: 2rem;
		font-size: 0.8rem;
	}

	.usermodule .btnpage2 a {
		margin-left: 0.5rem;
		margin-right: 0.5rem;
		background: #FFFFFF;
		position: relative;
	}

	.usermodule .btnpage2 span {
		border: 1px solid #d49f79;
		position: absolute;
		top: 2px;
		right: 2px;
		left: 2px;
		bottom: 2px;
	}

	.usermodule .pagebtn11 {
		display: inline-block;
		width: 5rem;
		height: 2rem;
		line-height: calc(2rem - 6px);
	}
	.pageselect{
		background: #a2693f !important;
		color: #FFFFFF !important;
	}
	.usermodule .pagebtn22 {
		width: 2rem;
		height: 2rem;
		display: inline-block;
		line-height: calc(2rem - 6px);
	}

	.usermodule .pagebtn11,
	.usermodule .pagebtn22 {
		color: #d49f79;
		font-size: 0.9rem;
	}

	.usermodule .pagebtn1,
	.usermodule .pagebtn2 {
		padding: 0.2rem 0.5rem;
		color: #d49f79;
		font-size: 0.9rem;
		line-height: 1.6rem;
	}

	.usermodule .pagebtn1 {
		border: 1px solid #d49f79;
	}

	.usermodule .mr {
		margin-right: 0.5rem;
	}

	.usermodule .ml {
		margin-left: 0.5rem;
	}
</style>
